import Vue from 'vue'
import Router from 'vue-router'
import kbxmList from '../views/kbxmList.vue'
import login from '../views/login.vue'
import xmlc from '../views/xmlc.vue'

import qd from '../views/qd.vue'
import jmCom from '../components/jmCom'

import xbjl from '../views/xbjl.vue'
import yxxsc from '../views/yxxsc.vue'
import jm from '../views/jm.vue'
import cb from '../views/cb.vue'
import kbbb from '../views/kbbb.vue'
import fhxsc from '../views/fhxsc.vue'
import zbhxr from '../views/zbhxr.vue'
import kbjs from '../views/kbjs.vue'
import tbView from '../views/tbView.vue'
import dybb from '../views/dybb.vue'
import tjzbhxr from '../views/tjzbhxr.vue'
import tjzbhxrKpyt from '../views/tjzbhxrKpyt.vue'
import zgfhxsc from '../views/zgfhxsc.vue'
import zgfhxscKpyt from '../views/zgfhxscKpyt.vue'

import adminIndex from '../views/adminIndex.vue'
import zygl from '../views/admin/zygl.vue'
import qxgl from '../views/admin/qxgl.vue'
import jsgl from '../views/admin/jsgl.vue'
import dlgl from '../views/admin/dlgl.vue'
import gsjggl from '../views/admin/gsjggl.vue'
import lcpz from '../views/admin/lcpz.vue'
import lcgl from '../views/admin/lcgl.vue'
import mbgl from '../views/admin/mbgl.vue'
import kbsz from '../views/admin/kbsz.vue'


Vue.use(Router)
export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/login',
            name: 'login',
            component: login
        },
        {
            path: '/sxt',
            name: 'sxt',
            component: () => import('../components/video/sxt.vue'),
            meta: { auth: true },
        },
        {
            path: '/testjm',
            name: 'jmCom',
            component: jmCom
        },
        {
            path: '/adminIndex',
            name: 'adminIndex',
            component: adminIndex,
            meta: { auth: true },
            children: [
                {
                    path: '/zygl',
                    name: 'zygl',
                    component: zygl
                },
                {
                    path: '/qxgl',
                    name: 'qxgl',
                    component: qxgl
                },
                {
                    path: '/jsgl',
                    name: 'jsgl',
                    component: jsgl
                },
                {
                    path: '/dlgl',
                    name: 'dlgl',
                    component: dlgl
                },
                {
                    path: '/gsjggl',
                    name: 'gsjggl',
                    component: gsjggl
                },
                {
                    path: '/lcgl',
                    name: 'lcgl',
                    component: lcgl
                },
                {
                    path: '/lcpz',
                    name: 'lcpz',
                    component: lcpz
                },
                {
                    path: '/mbgl',
                    name: 'mbgl',
                    component: mbgl
                },
                {
                    path: '/kbsz',
                    name: 'kbsz',
                    component: kbsz
                },
            ]

        },
        {
            path: '/kbxmList',
            name: 'kbxmList',
            component: kbxmList,
            meta: { auth: true },
        },
        {
            path: '/xmlc',
            name: 'xmlc',
            component: xmlc,
            meta: { auth: true },
            children: [
                {
                    path: '/bj',
                    name: 'bj',
                    component: () => import('../views/ncbj.vue'),
                    meta: { auth: true }
                },
                {
                    path: '/hybj',
                    name: 'bj',
                    component: () => import('../views/hybj.vue'),
                    meta: { auth: true }
                },
                {
                    path: '/tybj',
                    name: 'tybj',
                    component: () => import('../views/tybj.vue'),
                    meta: { auth: true }
                },
                {
                    path: '/tbView',
                    name: 'tbView',
                    component: tbView,
                    meta: { auth: true }
                },
                {
                    path: '/qd',
                    name: 'qd',
                    component: qd,
                    meta: { auth: true }
                },
                {
                    path: '/xbjl',
                    name: 'xbjl',
                    component: xbjl,
                    meta: { auth: true },
                },
                {
                    path: '/yxxsc',
                    name: 'yxxsc',
                    component: yxxsc,
                    meta: { auth: true },
                },
                {
                    path: '/jm',
                    name: 'jm',
                    component: jm,
                    meta: { auth: true },
                },
                {
                    path: '/cb',
                    name: 'cb',
                    component: cb,
                    meta: { auth: true },
                },
                {
                    path: '/kbbb',
                    name: 'kbbb',
                    component: kbbb,
                    meta: { auth: true },
                },
                {
                    path: '/fhxsc',
                    name: 'fhxsc',
                    component: fhxsc,
                    meta: { auth: true },
                },
                {
                    path: '/zbhxr',
                    name: 'zbhxr',
                    component: zbhxr,
                    meta: { auth: true },
                },
                {
                    path: '/dybb',
                    name: 'dybb',
                    component: dybb,
                    meta: { auth: true },
                },
                {
                    path: '/kbjs',
                    name: 'kbjs',
                    component: kbjs,
                    meta: { auth: true },
                },
                {
                    path: '/tjzbhxr',
                    name: 'tjzbhxr',
                    component: tjzbhxr,
                    meta: { auth: true },
                },
                {
                    path: '/tjzbhxrKpyt',
                    name: 'tjzbhxrKpyt',
                    component: tjzbhxrKpyt,
                    meta: { auth: true },
                },
                {
                    path: '/zgfhxsc',
                    name: 'zgfhxsc',
                    component: zgfhxsc,
                    meta: { auth: true },
                },
                {
                    path: '/zgfhxscKpyt',
                    name: 'zgfhxscKpyt',
                    component: zgfhxscKpyt,
                    meta: { auth: true }
                },
                //询比多次报价
                {
                    path: '/xbdcbj',
                    name: 'xbdcbj',
                    component: () => import('../views/xb/xbdcbj.vue'),
                    meta: { auth: true }
                },
                // 询比-唱标
                {
                    path: '/xbcb',
                    name: 'xbcb',
                    component: () => import('../views/xb/xbcb.vue'),
                    meta: { auth: true }
                },
                // 询比-符合性审查
                {
                    path: '/xbfhxsc',
                    name: 'xbfhxsc',
                    component: () => import('../views/xb/xbfhxsc.vue'),
                    meta: { auth: true }
                },
                // 询比-推荐中标候选人
                {
                    path: '/xbtjzbhxr',
                    name: 'xbtjzbhxr',
                    component: () => import('../views/xb/xbtjzbhxr.vue'),
                    meta: { auth: true }
                },
                // 文化空间-综合评分法-符合性审查
                {
                    path: '/bjfhxsc',
                    name: 'bjfhxsc',
                    component: () => import('../views/bj/bjfhxsc.vue'),
                    meta: { auth: true }
                },
                // 文化空间-综合评分法-推荐中标候选人
                {
                    path: '/bjtjzbhxr',
                    name: 'bjtjzbhxr',
                    component: () => import('../views/bj/bjtjzbhxr.vue'),
                    meta: { auth: true }
                },

                //龙游开评一体-倒计时
                {
                    path: '/kpytKbdjs',
                    name: 'kpytKbdjs',
                    component: () => import('../views/kpyt/kbdjs.vue'),
                    meta: { auth: true }
                },
                //龙游唱标
                {
                    path: '/lycb',
                    name: 'lycb',
                    component: () => import('../views/kpyt/lycb.vue'),
                    meta: { auth: true }
                },
                //龙游开评一体-符合性审查
                {
                    path: '/kpytFhxsc',
                    name: 'kpytFhxsc',
                    component: () => import('../views/kpyt/fhxsc.vue'),
                    meta: { auth: true }
                },
                {
                    path: '/kpytTjzbhxr',
                    name: 'kpytTjzbhxr',
                    component: () => import('../views/kpyt/tjzbhxr.vue'),
                    meta: { auth: true }
                }
            ]
        },
        {
            path: '/lookTbwj',
            name: 'LookTbwj',
            component: () => import('@/views/components/lookTbwj'),
        },
        {
            path: '/newLookTbwj',
            name: 'newLookTbwj',
            component: () => import('@/views/components/newLookTbwj'),
        },
        // 竞争性比选
        {
            path: '/bxxmlc',
            name: 'bxxmlc',
            component: () => import('../views/CompetitiveSelection/bxxmlc.vue'),
            meta: { auth: true },
            children: [
                {
                    path: '/bxKbdjs',
                    name: 'bxKbdjs',
                    component: () => import('../views/CompetitiveSelection/bxKbdjs.vue'),
                    meta: { auth: true }
                },
                {
                    path: '/bxKb',
                    name: 'bxKb',
                    component: () => import('../views/CompetitiveSelection/bxKb.vue'),
                    meta: { auth: true }
                },
                {
                    path: '/bxTjzbhxr',
                    name: 'bxTjzbhxr',
                    component: () => import('../views/CompetitiveSelection/bxTjzbhxr.vue'),
                    meta: { auth: true }
                },
                {
                    path: '/bxKbjlb',
                    name: 'bxKbjlb',
                    component: () => import('../views/CompetitiveSelection/bxKbjlb.vue'),
                    meta: { auth: true }
                },
                {
                    path: '/bxKbjs',
                    name: 'bxKbjs',
                    component: () => import('../views/CompetitiveSelection/bxKbjs.vue'),
                    meta: { auth: true }
                },
            ]
        },
        //抽签
        {
            path: "/draw",
            name: 'Draw',
            component: () => import('../views/components/draw.vue')
        },
        {
            path: "/cqxflDraw",
            name: 'CqxflDraw',
            component: () => import('../views/components/cqxflDraw.vue')
        },
        {
            path: "/fhxscDraw",
            name: 'FhxscDraw',
            component: () => import('../views/components/fhxscDraw.vue')
        },
        {
            path: "/tjzbhxrDraw",
            name: 'tjzbhxrDraw',
            component: () => import('../views/components/tjzbhxrDraw.vue')
        },
        {
            path: "/sxtFullScreen",
            name: 'sxtFullScreen',
            component: () => import('@/views/components/sxtFullScreen.vue')
        },
        {
            path: "/gcDraw",
            name: 'gcDraw',
            component: () => import('../views/components/gcDraw.vue')
        },
    ]
})
/**
 * 重写路由的push方法
 * 解决，相同路由跳转时，报错
 */
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
